module.exports = __webpack_public_path__ + "img/boy.edaa51f9.svg";